import React, { useState, useEffect, useCallback } from "react";
import { getRequest, postRequest, deleteRequest, patchRequest } from "../../../utils/requests";
import TextInput from "../../UI/Inputs/txtInput";
import DropDownInput from "../../UI/Inputs/dropInput"
import SubmitButton from "../../UI/Buttons/submitButton";
import FormMsg from "../../UI/Misc/formMsg";
import useLoadbarStore from "../../../stores/useLoadbarStore";

const CollaboratorManagement = ({ appUuid }) => {
  const [collaborators, setCollaborators] = useState([]);
  const [newCollaborator, setNewCollaborator] = useState({ email: "", role: "editor" });
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchCollaborators = useCallback(async () => {
    setLoading(true);
    const response = await getRequest(`/api/panel/apps/${appUuid}/collaborators`);
    if (response.error) {
      setMsg(response.error);
    } else {
      setCollaborators(response);
    }
    setLoading(false);
  }, [appUuid]);

  useEffect(() => {
    fetchCollaborators();
  }, [fetchCollaborators]);

  const handleAddCollaborator = async (e) => {
    e.preventDefault();
    setLoading(true);
    useLoadbarStore.getState().progressTo(15);

    const response = await postRequest(`/api/panel/apps/${appUuid}/collaborators`, newCollaborator);
    if (response.error) {
      setMsg(response.error);
      useLoadbarStore.getState().setToError(true);
    } else {
      setCollaborators((prevCollaborators) => [...prevCollaborators, response]);
      setNewCollaborator({ email: "", role: "editor" });
      useLoadbarStore.getState().progressTo(100);
    }
    setLoading(false);
  };

  const handleRemoveCollaborator = async (collaboratorId) => {
    setLoading(true);
    useLoadbarStore.getState().progressTo(15);

    const response = await deleteRequest(`/api/panel/apps/${appUuid}/collaborators/${collaboratorId}`);
    if (response.error) {
      setMsg(response.error);
      useLoadbarStore.getState().setToError(true);
    } else {
      setCollaborators((prevCollaborators) => prevCollaborators.filter((c) => c.id !== collaboratorId));
      useLoadbarStore.getState().progressTo(100);
    }
    setLoading(false);
  };

  const handleEditCollaborator = async (collaboratorId, newRole) => {
    setLoading(true);
    useLoadbarStore.getState().progressTo(15);

    const response = await patchRequest(`/api/panel/apps/${appUuid}/collaborators/${collaboratorId}`, { role: newRole });
    if (response.error) {
      setMsg(response.error);
      useLoadbarStore.getState().setToError(true);
    } else {
      setCollaborators((prevCollaborators) =>
        prevCollaborators.map((c) => (c.id === collaboratorId ? response : c))
      );
      useLoadbarStore.getState().progressTo(100);
    }
    setLoading(false);
  };

  return (
    <div>
      <h3>Collaborators</h3>
      <form onSubmit={handleAddCollaborator}>
        <TextInput
          name="email"
          type="email"
          label="Collaborator Email"
          value={newCollaborator.email}
          onChange={(e) => setNewCollaborator({ ...newCollaborator, email: e.target.value })}
          required
        />
        <DropDownInput
          name="role"
          label="Role"
          value={newCollaborator.role}
          onChange={(e) => setNewCollaborator({ ...newCollaborator, role: e.target.value })}
          required
        >
          <option value="editor">Editor</option>
          <option value="viewer">Viewer</option>
        </DropDownInput>
        <SubmitButton disabled={loading}>Add Collaborator</SubmitButton>
      </form>
      <FormMsg msg={msg} />
      <br />
      <br />
      <div>
        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="collaborator-list">
            {collaborators.map((collaborator) => (
              <div key={collaborator.id} className="collaborator-item" style={{border: '1px solid #ccc', padding: '5px', marginBottom: '10px', overflowX: "ellipsis", borderRadius: "10px"}}>
                <h4 className="collaborator-email" style={{fontSize: "12pt", fontWeight: "medium", color: "var(--main-accent-color)"}}>{collaborator.email}</h4>
                <div className="collaborator-options">
                  <DropDownInput
                    name={`role_${collaborator.id}`}
                    value={collaborator.role}
                    onChange={(e) => handleEditCollaborator(collaborator.id, e.target.value)}
                    style={{ display: 'inline-block', marginRight: '10px', width: '150px' }}
                  >
                    <option value="editor">Editor</option>
                    <option value="viewer">Viewer</option>
                  </DropDownInput>
                  <button
                    type="button"
                    className="flatbut remove-collaborator"
                    onClick={() => handleRemoveCollaborator(collaborator.id)}
                  >
                    <i className="material-icons">close</i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CollaboratorManagement;